import React, { useEffect, useState } from 'react'
import { getDonation } from '../Common/apis';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Loader from '../Components/Loader/Loader';

function Donation() {
    const [donation, setDonation] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchDonation = async () => {
        setLoading(true);
        try {
            const response = await getDonation();
            setDonation(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDonation();
    }, []);

    return (
        <>
        {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/about/donation.svg" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Donation</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-DONATION</p>
                    </div>
                </div>
            </div>
            <section className='pt-[74px]'>
                <p className='font-[500] font-inter text-[18px] text-[#FF6000] pb-[6px] text-center'>DONATION</p>
                <h6 className='font-[700] font-manrope md:text-[50px] text-[30px] text-center text-[#000000] md:pb-[60px] pb-[20px] max-w-[572px] w-full mx-auto'>
                    Give & Donate Now
                    <span className='text-[#FF6000]'> Find People Lifes</span>
                </h6>
                <div className="grid md:grid-cols-3 grid-cols-1 md:gap-[30px] gap-[20px] md:px-[154px] px-[30px] md:pb-[150px] pb-[60px]">
                    {donation?.map((e, i) => {
                        const endDate = new Date(e?.Campaign?.CampaignEndDate);
                        const today = new Date();
                        const timeDiff = endDate - today;
                        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

                        return (
                            <div key={i} className="px-2">
                                <Link to={`/donation-details/${e?.Campaign?._id}`}>
                                    <img src={e?.Campaign?.Image} className='w-full h-[185px] object-cover rounded-t-[16px]' alt="" />
                                    <div className='rounded-b-lg-[16px] p-[12px] bg-[#FDFDFD]' style={{ boxShadow: "0px 0px 4px 0px #00000014" }}>
                                        <div className="flex items-center gap-[4px] ">
                                            <p className="font-[400] font-manrope text-[16px] text-[#4D4D4D]">{e?.Campaign?.CampaignCategory}</p>
                                            <img src="/assets/home/blue-tick.png" alt="" />
                                        </div>
                                        <p className="font-[700] text-[20px] font-manrope text-[#333333] pb-[4px]">
                                            {e?.Campaign?.CampaignName}
                                        </p>
                                        <input
                                            type="range"
                                            id="range"
                                            min="0"
                                            max={e?.Campaign?.TotalRequiredDonation}
                                            value={e?.Campaign?.ReceivedDonation}
                                            className="w-full accent-[#FF6000]"
                                        />
                                        <div className='flex justify-between items-center'>
                                            <div>
                                                <p className="font-[400] font-manrope text-[11px] text-[#666666]">Raised</p>
                                                <h6 className="font-[700] font-manrope text-[20px] text-[#141414]">{e?.Campaign?.TotalRequiredDonation}</h6>
                                            </div>
                                            <div>
                                                <p className="font-[400] font-manrope text-right text-[11px] text-[#666666]">Days left</p>
                                                <h6 className="font-[700] font-manrope text-right text-[20px] text-[#141414]">
                                                    {daysLeft > 0 ? daysLeft : 'Ended'}
                                                </h6>
                                            </div>
                                        </div>
                                        <button className='font-[600] text-[18px] font-manrope w-full text-center text-[#FFFFFF] rounded-[6px] mt-[6px] py-[12.5px]' style={{ background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)" }}>
                                            Donate
                                        </button>
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </section>
        </>
    )
}

export default Donation